import { createColumnHelper } from '@tanstack/react-table';
import { PlatformProfileResult } from '@mews-commander/data-access';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Body, ColumnFilterType } from '@optimus-web/core';
import { PlatformProfile2FATag } from '../Common/PlatformProfile2FATag';
import { PlatformProfileStatusTag } from './PlatformProfileStatusTag';
import { PlatformProfileTableAvatar } from './PlatformProfileTableAvatar';

const columnHelper = createColumnHelper<PlatformProfileResult>();

export const platformProfileColumns = [
    columnHelper.accessor('fullName', {
        id: 'name',
        header: () => <LocalizedText textKey={TextKey.Name} />,
        cell: (props) => <PlatformProfileTableAvatar platformProfile={props.row.original} />,
        meta: {
            width: 300,
        },
    }),
    columnHelper.accessor('email', {
        header: () => <LocalizedText textKey={TextKey.Email} />,
        cell: (props) => (
            <Body size="small" ellipsis maxLines={1}>
                {props.getValue()}
            </Body>
        ),
    }),
    columnHelper.accessor('role', {
        header: () => <LocalizedText textKey={TextKey.Role} />,
        cell: (props) => {
            const value = props.getValue();
            return value ? (
                <Body size="small" ellipsis maxLines={1}>
                    {value}
                </Body>
            ) : (
                UnicodeEntity.Dash
            );
        },
        meta: {
            filtersType: ColumnFilterType.String,
        },
    }),
    columnHelper.accessor('status', {
        header: () => <LocalizedText textKey={TextKey.Status} />,
        cell: ({ getValue }) => <PlatformProfileStatusTag status={getValue()} />,
    }),
    columnHelper.accessor('twoFactorAuthenticationEnabled', {
        header: () => <LocalizedText textKey={TextKey.TwoFactorAuthentication2FA} />,
        cell: ({ getValue }) => <PlatformProfile2FATag isEnabled={!!getValue()} />,
        meta: {
            filtersType: ColumnFilterType.Bool,
        },
    }),
];
